window.REST_API_URL = "/api/mhk";
window.PATH_AUTOSUGGEST = "autosuggest";
window.PATH_SEARCH = "search";
window.PATH_USERMANAGEMENT = "user_management/user";
window.PATH_USER = "user";
window.IMG_PATH = "/images/";
window.IHT_API_URL = "https://test-dmz-lobster.mhk.net/dw/Request/macrocom";
